import {
  Component,
  ChangeDetectionStrategy,
  Input,
  EventEmitter,
  Output,
  OnChanges,
  SimpleChanges,
  inject,
} from '@angular/core';
import { takeUntil } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';
import { ViewMode } from '@src/models';
import { AlertService } from '@src/core/services';
import { BaseComponent } from '@src/app/modules/base';

import { ContactsCustomListItem } from '../../types';
import { CustomListService } from '../../services';

@Component({
  selector: 'values-list',
  templateUrl: './values-list.component.html',
  styleUrls: ['./values-list.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ValuesListComponent extends BaseComponent implements OnChanges {
  private readonly customListService = inject(CustomListService);
  private readonly alertService = inject(AlertService);
  private readonly translateService = inject(TranslateService);

  @Input() selectedDirectory?: ContactsCustomListItem;
  @Output() return = new EventEmitter<void>();

  customListValues$ = this.customListService.customListValues$;
  mode: ViewMode = 'view';

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.selectedDirectory) {
      if (this.selectedDirectory?.id) {
        this.customListService.getCustomListValues(this.selectedDirectory.id);
      }
    }
  }

  onSave(values: ContactsCustomListItem[]) {
    if (!this.selectedDirectory?.id) return;

    this.customListService
      .saveValues(values, this.selectedDirectory.id)
      .pipe(takeUntil(this.destroyed$$))
      .subscribe({
        complete: () => {
          this.mode = 'view';

          this.alertService.success(this.translateService.instant('common.alerts.successes.saveData'));

          if (this.selectedDirectory?.id) {
            this.customListService.getCustomListValues(this.selectedDirectory.id);
          }
        },
      });
  }

  removeItem(value: string) {
    this.customListService
      .deleteCustomListValueObservable(value)
      .pipe(takeUntil(this.destroyed$$))
      .subscribe(() => {
        if (this.selectedDirectory?.id) {
          this.customListService.getCustomListValues(this.selectedDirectory.id);
        }
      });
  }
}
